import type { ListingProduct } from '~/models/ListingProduct.api.model';
import FetchFactory from '../factory';
import type { GetCellPhoneWithFamilyPlanCostByProductLinkUrlRequest } from '~/models/cellphone_page/WithFamilyPlanCostRequest.model';

const CONTROLLER = '/api-electra/CellPhonePage';

class CellPhonePageModule extends FetchFactory<any> {
  async getCellPhoneByProductLinkUrl(url: string): Promise<ListingProduct> {
    const parsedUrl = url.replaceAll('/', '%2F');
    const requestUrl = `${CONTROLLER}/GetCellPhoneByProductLinkUrl?productLinkUrl=${parsedUrl}`;

    return await this.get(requestUrl);
  }

  async getCellPhoneWithFamilyPlanCostByProductLinkUrlAsync(
    requestParams: GetCellPhoneWithFamilyPlanCostByProductLinkUrlRequest,
  ): Promise<ListingProduct> {
    const baseUrl = `${CONTROLLER}/GetCellPhoneWithFamilyPlanCostByProductLinkUrl/family-plan`;
    const productUrlParam = requestParams.productLinkUrl.replaceAll('/', '%2F');
    const queryString = `?productLinkUrl=${productUrlParam}&mainBundlePriceId=${requestParams.mainBundlePriceId}&mainMsisdnOptionId=${requestParams.mainMsisdnOptionId}&familyBundlePriceId=${requestParams.familyBundlePriceId}&noOfFamilyPlans=${requestParams.noOfFamilyPlans}&bindingPeriodId=${requestParams.bindingPeriodId}`;
    const url = `${baseUrl}${queryString}`;

    return await this.get(url);
  }
}

export default CellPhonePageModule;
